import { BooleanInput } from '@angular/cdk/coercion';
import { AsyncPipe, CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
    effect,
    signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AvatarComponent } from 'app/components/avatar/avatar.component';
import { User } from 'app/core/interfaces/user';
import { FirebaseStorageUrlPipe } from 'app/core/pipes/firebase-storage-url.pipe';
import { UserService } from 'app/modules/sho_management_pro/user/services/user.service';
import { UserDetailsComponent } from 'app/modules/sho_management_pro/user/templates/user-details/user-details.component';
import { DialogService } from 'app/services/dialog.service';
import { ThemeService } from 'app/services/theme.service';
import { UiService } from 'app/services/ui.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-user-menu',
    standalone: true,
    imports: [
        CommonModule,
        FirebaseStorageUrlPipe,
        AsyncPipe,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatDividerModule,
        AvatarComponent,
    ],
    templateUrl: './user-menu.component.html',
    styleUrl: './user-menu.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user!: User;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private detailsDialog = UserDetailsComponent;
    isDarkMode = signal<boolean>(false);

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _uiService: UiService,
        private _themeService: ThemeService,
        private dialogService: DialogService
    ) {
        effect(() => {
            this.user = this._userService.user;

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    // ----------------------------------------------------------------------
    // @ Lifecycle hooks
    // ----------------------------------------------------------------------

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------

    loadCurrentUserInfo(): void {
        this.dialogService.openModal(this.detailsDialog, this.user);
    }

    /**
     * Update the user status
     *
     * @param status
     */
    // updateUserStatus(status: string): void {
    //     // Return if user is not available
    //     if (!this.user) {
    //         return;
    //     }

    //     // Update the user
    //     this._userService
    //         .update({
    //             ...this.user,
    //             status,
    //         })
    //         .subscribe();
    // }

    switchMode(): void {
        this._themeService.toggleMode();
        this.isDarkMode.set(this._themeService.isDark());
    }

    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
}
